export default {
  drawer: null,
  color: 'blue',
}
